import { render, staticRenderFns } from "./coursesView.vue?vue&type=template&id=169b9170"
import script from "./coursesView.vue?vue&type=script&lang=js"
export * from "./coursesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports